module.exports = __webpack_public_path__ + "8c944916e47dd72c19e7727e8763337d.svg";